import React, { useState } from 'react';
import { Box, IconButton, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import './multiSearch.scss'
import { IoIosNotifications, IoMdLogOut } from "react-icons/io";

import { useNavigate } from 'react-router-dom';
import { CiSettings } from "react-icons/ci";
import { useTheme } from '@emotion/react';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../../store/reducers/auth-slice';
import { IoIosSettings } from "react-icons/io";
import { MdFilterListAlt } from "react-icons/md";

const MultiSearch = (props) => {
    const { children } = props
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const theme = useTheme()
    const { user } = useSelector(state => state.auth)

    const [anchorEl, setAnchorEl] = useState(null);
    const isMenuOpen = Boolean(anchorEl);

    const handleMenuClose = (path) => {
        setAnchorEl(null);
    };


    const handleUserSettingMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };


    const menuId = "primary-search-account-menu";
    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
            }}
            classes={{ list: "header-person-details-list" }}
            id={menuId}
            keepMounted
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
            PaperProps={{
                elevation: 0,
                sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    background: theme.palette.headerBackgroundColor,
                    "& .MuiAvatar-root": {
                        width: 100,
                        height: 100,
                        ml: -0.5,
                        mr: 1,

                    },
                    "&:before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 5,
                        width: 10,
                        height: 10,
                        background: theme.palette.headerBackgroundColor,
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                    },
                },
            }}
        >
            <Box sx={{ width: '300px', }}>
                {children}
            </Box>
        </Menu>
    );
    return (
        <>
            <Tooltip title={'Filter'}>
                <Box className='userSettingContainer' onClick={handleUserSettingMenuOpen}>
                    <MdFilterListAlt size={25} color={theme.palette.textColor} />
                </Box>
            </Tooltip>
            {renderMenu}
        </>
    );
};


export default MultiSearch;